import { z } from 'zod';
/** Eventos de produto (DESIGN §7): só o nome e poucos atributos, nunca conteúdo nem dado pessoal. */
export const productEventNameSchema = z.enum([
    'landing_viewed',
    'landing_cta',
    'signup_started',
    'signup_completed',
    'login_completed',
    'activated',
    'paywall_viewed',
    'plan_viewed',
    'checkout_started',
    'checkout_completed',
    'feature_activated',
    /** Uma tela ou camada do app falhou no aparelho (só o lugar e o tipo do erro). */
    'client_error',
    /** Rascunho levado ao WhatsApp: a pessoa confirmou o envio (sent: true) ou voltou ao rascunho. */
    'whatsapp_handoff',
]);
const propValue = z.union([z.string().max(60), z.number().finite(), z.boolean()]);
export const trackEventSchema = z.object({
    name: productEventNameSchema,
    /** Identificador aleatório do aparelho antes de existir conta. */
    anonymousId: z.uuid().optional(),
    props: z
        .record(z.string().regex(/^[a-z_]{1,24}$/), propValue)
        .refine((value) => Object.keys(value).length <= 6, { message: 'Atributos demais.' })
        .optional(),
});
